import { Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  BackendDataSourceService,
  FilterView,
  FilterViewProviderDirective,
  ItemView,
  ItemViewProviderDirective,
  ListView,
  ListViewProviderDirective,
  NtapCommonComponent,
  UIComponents
} from '@ntap/core';
import { Subscription, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-spremiste-prostorije',
  templateUrl: './spremiste-prostorije.component.html',
  styleUrls: ['./spremiste-prostorije.component.scss']
})
export class SpremisteProstorijeComponent
  extends NtapCommonComponent
  implements OnInit
{
  INIT_COMP_ID = UIComponents.ITEMVIEW;
  constructor(protected itemViewProvider: ItemViewProviderDirective<ItemView>) {
    super();
  }

  backendService = inject(BackendDataSourceService);

  @ViewChild(FilterViewProviderDirective)
  filterViewProvider: FilterViewProviderDirective<FilterView>;

  filterSubscription: Subscription;

  @ViewChild(ListViewProviderDirective)
  listViewProvider: ListViewProviderDirective<ListView>;

  parentObjectName: string;
  parentObjectAdress: string;
  parentObjectArea: string;
  parentArchiveName: string;
  prostorijaName: string;

  ngOnInit(): void {
    this.addSubscription(
      this.itemViewProvider.item$
        .pipe(
          switchMap((data: any) => {
            this.prostorijaName =
              (data['earhiv~spremiste_prostorija~identifikator']
                ? data['earhiv~spremiste_prostorija~identifikator'] + ' '
                : '') +
              (data['earhiv~spremiste_prostorija~naziv']
                ? data['earhiv~spremiste_prostorija~naziv']
                : '');

            return this.backendService.getViewData('spremiste_objekti', {
              ['earhiv~spremiste_objekt~id']:
                data['earhiv~spremiste_prostorija~spremiste_objekt_id']
            });
          }),
          tap((parentObject: any) => {
            this.parentObjectName =
              parentObject[0]['earhiv~spremiste_objekt~identifikator'] +
              ' ' +
              (parentObject[0]['earhiv~spremiste_objekt~naziv']
                ? parentObject[0]['earhiv~spremiste_objekt~naziv'] + ' '
                : '');
            this.parentObjectAdress =
              parentObject[0]['earhiv~spremiste_objekt~adresa'];
            this.parentObjectArea =
              parentObject[0]['earhiv~spremiste_objekt~povrsina'];
          }),
          switchMap((item: any) =>
            this.backendService
              .getViewData('spremiste_nadredeni-arhiv', {
                ['en~arhiv_posjednik~id']:
                  item[0]['earhiv~spremiste_objekt~arhiv_id']
              })
              .pipe(
                tap((viewData: any) => {
                  this.parentArchiveName = viewData[0]['en~agent~naziv'];
                })
              )
          )
        )
        .subscribe()
    );
  }
}
